export const setRecordingStatus = (
    status: 'stopped' | 'recording' | 'processing' | 'error'
) => ({
    type: 'setRecordingStatus',
    payload: status,
})
